import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import {  PATIENT_API } from '../../ApiNames';


export const fetchData1 = (applications: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: applications,
});




export const fetchAPPLICATIONS = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {userid:uid};
            const apiname = PATIENT_API.patientapplications_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData1(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};



